import history from '@history';
import _ from 'lodash';
import { useDispatch } from 'react-redux';
import { yupResolver } from '@hookform/resolvers/yup';
import { Controller, useForm } from 'react-hook-form';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import WdPageSimple from '@main/core/WdPageSimple';
import { ButtonWithLoader, ComposedHeader, FormCardLayout } from '@main/components';
import { useRequest } from '@main/hooks';
import { showMessage } from 'app/store/core/messageSlice';
import { updatePassword } from 'src/app/api/profile';
import { passwordRecoveryDefaults } from '../Defaults/passwordRecovery';
import { schema } from '../Validators/PasswordRecovery';

const Root = styled(WdPageSimple)(({ theme }) => ({
  backgroundColor: '#FFF',
  '& .WdPageSimple-header': {},
  '& .WdPageSimple-content': {},
}));

export const PasswordRecovery = () => {
  const Dispatch = useDispatch();
  // ----- Inicializacion de validadores de formulario
  const { control, formState, handleSubmit, setValue } = useForm({
    mode: 'onChange',
    defaultValues: passwordRecoveryDefaults,
    resolver: yupResolver(schema),
  });
  const { isValid, dirtyFields, errors } = formState;
  // ------ Request Store New Password ------
  const { makeRequest: tryRecoveryPassword, isLoading } = useRequest(updatePassword);

  const onSubmit = (form) => {
    const recoveryForm = {
      ...form,
    };
    tryRecoveryPassword(recoveryForm)
      .then(({ isOk }) => {
        if (isOk) {
          Dispatch(
            showMessage({
              message: 'Información actualizada correctamente',
              autoHideDuration: 4000,
              anchorOrigin: {
                vertical: 'top',
                horizontal: 'center',
              },
              variant: 'success',
            })
          );
          history.back();
        }
      })
      .catch((error) => {
        Dispatch(
          showMessage({
            message: error.message,
            autoHideDuration: 4000,
            anchorOrigin: {
              vertical: 'top',
              horizontal: 'center',
            },
            variant: 'error',
          })
        );
      });
  };

  return (
    <Root
      header={<ComposedHeader decorator="button" />}
      content={
        <Box
          className="flex justify-center items-start"
          sx={{
            width: '100%',
            height: '100%',
          }}
        >
          <FormCardLayout title="Cambiar contraseña">
            <form
              autoComplete="off"
              name="adminRecoveryForm"
              noValidate
              className="flex flex-col justify-center w-full mt-8"
            >
              <FormCardLayout.FullColum>
                <div className="flex flex-col">
                  <Controller
                    name="password"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        className="mb-32"
                        label="Contraseña"
                        type="password"
                        error={!!errors.password}
                        helperText={errors?.password?.message}
                        variant="outlined"
                        fullWidth
                      />
                    )}
                  />
                  <Controller
                    name="password_confirmation"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        className="mb-32"
                        label="Confirmar contraseña"
                        type="password"
                        error={!!errors.password_confirmation}
                        helperText={errors?.password_confirmation?.message}
                        variant="outlined"
                        fullWidth
                      />
                    )}
                  />
                </div>
              </FormCardLayout.FullColum>
              <FormCardLayout.RowButton>
                <Button
                  onClick={() => history.back()}
                  variant="contained"
                  className="w-full md:w-auto"
                  color="info"
                >
                  Cancelar
                </Button>
                <ButtonWithLoader
                  onClick={handleSubmit(onSubmit)}
                  color="success"
                  aria-label="Cambiar contraseña"
                  variant="contained"
                  disabled={_.isEmpty(dirtyFields) || !isValid}
                  type="submit"
                  isLoading={isLoading}
                >
                  Cambiar
                </ButtonWithLoader>
              </FormCardLayout.RowButton>
            </form>
          </FormCardLayout>
        </Box>
      }
    />
  );
};
